import { FC, useCallback } from 'react';
import { trackEvent } from 'src/common/3rdParty/tracking';
import CapacityFilter, { CapacityFilterProps } from 'src/common/components/CapacityFilter';
import { GA_EVENT_FILTER } from 'src/common/gaEvents';

const GA_PARAM_CAPACITY = 'p1';

type FilterModalCapacityProps = Pick<CapacityFilterProps, 'value' | 'onChange'>;

const FilterModalCapacity: FC<FilterModalCapacityProps> = ({ value, onChange }) => {
  const handleCapacityChange = useCallback((capacityValue: number) => {
    onChange(capacityValue);
    trackEvent(GA_EVENT_FILTER, {
      [GA_PARAM_CAPACITY]: capacityValue,
    });
  }, [onChange]);

  return (
    <CapacityFilter
      value={value}
      classNameModifier="capacityFilter"
      onChange={handleCapacityChange}
    />
  );
};

export default FilterModalCapacity;
